<template>
  <div id="app">
    <vue-progress-bar />
    <router-view />
  </div>
</template>

<script>
// try 左側 icon 確認
import { VueProgressBar } from '@G/mixins/VueProgressBar'
import { mapGetters, mapMutations } from 'vuex'
import { getStorage } from '@GUTIL/other'
export default {
  name: 'App',
  mixins: [VueProgressBar],
  metaInfo() {
    return {
      title: this.platformName
    }
  },
  computed: {
    ...mapGetters(['folderName']),
    platformName() {
      let hasVal = !!this.folderName
      return hasVal
        ? this.$t(`i18n_xnb_${this.folderName.toLowerCase()}_platform`)
        : ''
    }
  },
  created() {
    this[_GM.SET_CONFIG_URL]()

    // if (!getStorage('access_token')) {
    //   this.$router.push({ name: 'Login' })
    // }
  },
  methods: {
    ...mapMutations(['SET_CONFIG_URL'])
  }
}
</script>
